import { client } from './utils'
import { errorReports as endpoints } from './api_urls'

export class ErrorReportUpdater {
  constructor(reportId) {
    this.url = endpoints.save({ reportId })
  }

  attach() {
    $('#close-report').click(() => {
      this.setReportStatus('closed')
    })

    $('#open-report').click(() => {
      this.setReportStatus('open')
    })

    $('#change-issue-id').click(e => {
      $('#issue-link').remove()
      this.replaceWithIssueInput($(e.target))
    })

    $('#add-issue-id').click(e => {
      this.replaceWithIssueInput($(e.target))
    })
  }

  replaceWithIssueInput(el) {
    el.parent().append($('<input id="issue-id" type="text" />'))
    el.remove()
    $('#issue-id').blur(e => {
      this.updateTrackerId($(e.target).val())
    })
    $('#issue-id').keyup(e => {
      if (e.which === 13) {
        this.updateTrackerId($(e.target).val())
      }
    })
  }

  updateTrackerId(issueId) {
    if (!issueId) return
    client
      .post(this.url, { issueId })
      .then(() => {
        window.location.reload()
      })
      .catch(e => {
        console.error(e)
      })
  }

  setReportStatus(status) {
    client
      .post(this.url, { status })
      .then(() => {
        window.location.reload()
      })
      .catch(e => {
        console.error(e)
      })
  }
}
